import React, { Fragment } from "react";
import Avatar from "../images/avatar.png";

export default ({ text }) => {
  return (
    <Fragment>
      <div className="columns is-desktop  ">
        <div className="column is-12 " style={{ padding: "0px" }}>
          <figure className="line-image ">
            <img className="img-avatar" src={Avatar} />
          </figure>
        </div>
      </div>
      {text && (
        <div className="column is-offset-1  is-10" style={{ padding: "0px" }}>
          <h1 className="is-size-5 has-text-centered">{text}</h1>
        </div>
      )}
    </Fragment>
  );
};
